import "./Sucess.css"



const Sucess = () => {
    return (
        <div className="thanks-container">
            <h2>Sucesso!</h2>
            <p>Seu formulário foi enviado!</p>
            <img className="gif" src="https://i.stack.imgur.com/EzFNr.gif" alt=""/>
        </div>

    )
}

export default Sucess;